import React, {Component} from 'react';
import './App.css';
import {Link} from "react-router-dom";
import BackButton from './BackButton';

const MailTo = ({mailto, label}) => {
  return (
    <Link
      className="app-link"
      to='#'
      onClick={(e) => {
        window.location = mailto;
        e.preventDefault();
      }}
    >
      {label}
    </Link>
  );
};

class About extends Component {

  render() {
    return (
      <div className="app">
        {this.props.navbar}
        <div className="page-container">
          <BackButton/>
          <span className="page-eyebrow">About</span>
          <h2 className="page-title">About SoReal</h2>

          <div className="surface-card surface-card-padded" style={{lineHeight: 1.7, fontSize: 15.5}}>
            <p>
              SoReal Inc is a Bay Area based fledgling startup created to add value to
              people interested in the Bay Area real estate.
            </p>

            <p style={{marginBottom: 0}}>
              To contact us, please email <MailTo label={"support@sorealinc.com"} mailto="mailto:support@sorealinc.com"/>.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
